import React from 'react';
import styles from './vicassessoriaesportiva.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5517981847704';
const WHATSAPP_MSG = 'Olá! Vim pelo cartão digital e gostaria de saber mais...';
const WHATSAPP_URL = `https://wa.me/5517981847704?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const INSTAGRAM_URL = 'https://www.instagram.com/vicassessoriaesportiva?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';

const buildWhatsAppLink = (message: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

/** Mensagem por banner — edite conforme o conteúdo de cada imagem */
const BANNER_WHATSAPP_MESSAGES = [
    'Oi, estou interessado(a) no serviço de consultoria de corrida de rua...',
    'Oi, estou interessado(a) no serviço de consultoria de musculação...',
    'Oi, estou interessado(a) em ingressar no grupo de corrida...',
    'Oi, estou interessado(a) no serviço de personal de corrida...',
    'Oi, estou interessado(a) no serviço de personal de musculação...',
] as const;

const Vicassessoriaesportiva: React.FC = () => {
    return (
        <div className={styles.vicassessoriaesportiva}>
            <div className={styles.page}>
                <div className={styles.hero}>
                    <img
                        src={require('./src/background-links.png')}
                        alt="Gustavo Alves - Personal trainer"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <div className={styles.statsRow}>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>+45</span>
                            <span className={styles.statLabel}>Clientes Ativos</span>
                        </div>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>6</span>
                            <span className={styles.statLabel}>Anos de experiência</span>
                        </div>
                    </div>
                    <div className={styles.socialRow}>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <WhatsappIcon height="32" color="#c54336" />
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="28" color="#c54336" />
                        </a>
                    </div>

                    {[
                        require('./src/banner-1.png'),
                        require('./src/banner-2.png'),
                        require('./src/banner-3.png'),
                        require('./src/banner-4.png'),
                        require('./src/banner-5.png'),
                    ].map((src, index) => (
                        <a
                            key={index}
                            href={buildWhatsAppLink(BANNER_WHATSAPP_MESSAGES[index])}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.bannerLink}
                        >
                            <img src={src} alt="VIC ASSESSORIA ESPORTIVA" className={styles.banner} />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Vicassessoriaesportiva;
